module.exports = "/static/assets/5def583480c419619a97dc969d2ab1c2.png";